import { getCookie, getValueFromCookie } from '@/utils/cookie';
import Constants from '@/constants/const';

/*
 * 获取邀请好友的参数
 */
export const getInviterParams = (ctx?) => {
  return [Constants.REFERRER_ID, Constants.REFERRER_SOURCE].reduce((pre, cur) => {
    const value = getCookie(cur, ctx);
    if (value) {
      pre[cur] = value;
    }
    return pre;
  }, {});
};

/**
 *
 * @returns 获取返利联盟用户id
 */
export const getReferralIdFromCookie = (ctx?) => {
  let referralId = getCookie(Constants.REFERRAL_ID, ctx) || ctx?.req?.[Constants.REFERRAL_ID];
  if (!referralId) {
    return 0;
  }
  referralId = decodeURIComponent(referralId);
  const referralIdArray = referralId.split(':') || [];
  if (referralIdArray.length !== 2) {
    return 0;
  }
  if (+referralIdArray[1] + 3600 * 2 < new Date().getTime() / 1000) {
    return 0;
  }
  return +referralIdArray[0] || 0;
};

//获取邀请好友的id
export const getReferrerId = (ctx?) => {
  return getValueFromCookie(Constants.REFERRER_ID, ctx);
};
